import { P } from 'atoms/Typography';
import { useTranslations } from 'modules/i18n/useTranslations';
import styles from './styles.module.css';

export const PasswordRules = () => {
  const t = useTranslations();

  return (
    <div className={styles.rulesContainer}>
      <div className={styles.rules}>
        <P className={styles.text}>{t('common.errors.password.length')}</P>
        <P className={styles.text}>
          {t('common.errors.password.number-and-letter')}
        </P>
        <P className={styles.text}>{t('common.errors.password.not-email')}</P>
        <P className={styles.text}>
          {t('common.errors.password.not-password')}
        </P>
      </div>
    </div>
  );
};
